export class OrganizationPaperworkOptionModel {
	success: boolean;
	paperwork_types: string[];
}

export function OrganizationPaperworkOptionModel_ClassTransform_Type() {
	return OrganizationPaperworkOptionModel;
}
